import { useEffect } from 'react';

import { ALL_OPTION_KEY } from '@/common/constants';
import { API_URL } from '@/dtos';
import { ReportSummaryResponse } from '@/modules/Reports/report.types';

import { useBaseReportSummaryQuery } from '../../queries';
import { PlanOmnibusBalanceSummaryReportParams } from '../PlanOmnibusBalanceReport.types';

export const QUERY_KEY = 'GET_REPORT_PLAN_OMNIBUS_BALANCE_SUMMARY';
const usePlanOmnibusBalanceReportSummaryQuery = (params: PlanOmnibusBalanceSummaryReportParams) => {
  const {
    data,
    isLoading,
    isLoadingMore,
    isSuccess,
    isEmptyData,
    lastTimeUpdateDate,
    planOptions,
    isEmptyPlanOptions,
    isHasNextPage,
    handleLoadMore,
    resetPagination,
  } = useBaseReportSummaryQuery<ReportSummaryResponse>(
    API_URL.REPORTS_PLAN_OMNIBUS_BALANCE_REPORT_SUMMARY,
    [QUERY_KEY, params.employerId, params?.planYearPeriod, params?.planIds.join(',')],
    {
      employer_id: params.employerId,
      plan_year_period:
        params?.planYearPeriod && !params?.planYearPeriod.includes(ALL_OPTION_KEY)
          ? params?.planYearPeriod.join(',')
          : undefined,
      plan_ids:
        params?.planIds && !params?.planIds.includes(ALL_OPTION_KEY) ? params?.planIds.join(',') : undefined,
    },
    {
      disabled: !params.employerId && !params.employerIds?.length,
      employerId: params.employerId,
      employerIds: params.employerIds,
    }
  );

  useEffect(() => {
    resetPagination();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.employerId, params?.planYearPeriod?.join(','), params?.planIds.join(',')]);

  return {
    isEmptyData,
    isEmptyPlanOptions,
    lastTimeUpdateDate,
    planOptions,
    data,
    isLoading,
    isLoadingMore,
    isSuccess,
    isHasNextPage,
    handleLoadMore,
  };
};

export default usePlanOmnibusBalanceReportSummaryQuery;
